module.exports = __webpack_public_path__ + "static/media/mobile-discover-shopping-centre.015e69d2.png";